import { MenuItem, Select } from "@mui/material";

function CustomerSelect ({customers, selectedCustomerId, onChangeCustomer, error, ...props}) {

  const customerItems = [
      {key: "customer_not_selected", value: "customer_not_selected", label: "[未選択]"},
      ...(customers.map((customer) => (
        {
          key: `customer_${customer.customerId}`, 
          value: customer.customerId.toString(), 
          label: customer.customerName
        }
      )))
    ];

  const MenuItems = customerItems.map((item) => (
    <MenuItem key={item.key} value={item.value}>
      {item.label}
    </MenuItem>
  ));

  const handleChangeCustomerSelect = (e) => {
    const selectValue = e.target.value;
    onChangeCustomer(selectValue === "customer_not_selected" ? null : parseInt(selectValue));
  }

  return (
    <Select
      labelId={props.lavelId || ''}
      value={selectedCustomerId || 'customer_not_selected'}
      onChange={handleChangeCustomerSelect}
      error={error}
      {...props}
    >
      {MenuItems}
    </Select>
  )
}

export default CustomerSelect;

